import { BarcodeAttributes } from '@/types'
import { UpdateBarcodeMutation } from './__generated__/update_mutation'
import { Mutation as UpdateMutation } from './update_mutation'
import { useForm } from '@/helpers/useForm'
import { EditBarcodeQuery } from './__generated__/edit_query'
import { Query as EditQuery } from './edit_query'
import { Inline as Loading } from '@/components/loading'
import { Inline as Error } from '@/components/error'

type Barcode = EditBarcodeQuery['barcodes']['nodes'][0]

interface Props {
  id: string
}

export const Form = ({ id }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    queryError,
    queryLoading,
    mutationLoading,
    attributes,
  } = useForm<UpdateBarcodeMutation, BarcodeAttributes, EditBarcodeQuery, Barcode>({
    id,
    initializer: barcode => ({
      barcodeNumber: barcode.barcodeNumber
    }),
    query: EditQuery,
    queryKey: 'barcodes',
    mutation: UpdateMutation,
    resultKey: 'updateBarcode'
  })

  if (queryLoading) return <Loading />

  console.log(attributes)

  return (
    <>
      { queryError && <Error message={queryError} /> }
      <div className="flex flex-col gap-6">
        { formBuilder.buildQueryError() }
        { formBuilder.buildField({ name: 'Barcode Number', field: 'barcodeNumber', type: 'positive-integer' }) }
        { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
      </div>
    </>
  )
}
